<template>
  <div class="">
    <div v-if="isShow" class="pt16 pb16 bg_white">
      <div class="title_wrap mr16">
        <SectionTitle :title="'履歴'" :width="'122'" />
        <button @click="modalOpen" class="btn calendar_btn">
          <img :src="require('@/assets/images/common/calendar.svg')" alt="">
        </button>
      </div>
      <div class="search">
        <button @click="searchWalletAmountType('ALL')" class="search_btn rb" :class="{ 'select': isWalletAmountType == 'ALL' }">すべて</button>
        <button @click="searchWalletAmountType('CASH')" class="search_btn rb" :class="{ 'select': isWalletAmountType == 'CASH' }">キャッシュバック</button>
        <button @click="searchWalletAmountType('POINT')" class="search_btn rb" :class="{ 'select': isWalletAmountType == 'POINT' }">ポイント</button>
      </div>
      <div class="date_wrap ml16 mt48 mr16">
        <p class="date rb c5a">{{ formatDate(fromDate, "yyyy年MM月dd日") }}</p>
        <span class="wave rb">〜</span>
        <p class="date rb c5a">{{ formatDate(toDate, "yyyy年MM月dd日") }}</p>
      </div>

      <div class="cashflow mt24">
        <div v-if="cashFlowList.length > 0 && is_cashFlow_show">
          <div class="cashflow_item ml16 mr16" v-for="(val, index) in cashFlowList" :key="index">
            <div class="cashflow_detail">
              <h2 class="cashflow_title rb c5a">{{ val.cashFlowName }}</h2>
              <p class="cashflow_text rr">{{ formatDate(val.dateTimeText, "yyyy年MM月dd日 HH時mm分") }}</p>
            </div>
            <div class="cashflow_price">
              <p class="price rm" :class="{ plus: val.walletCashFlowType == 'DEPOSIT', minus: val.walletCashFlowType == 'WITHDRAWAL' }">{{ val.amountText }}</p>
              <p v-if="val.expiredDateText != ''" class="expired cashflow_text rr">利用期限: {{ val.expiredDateText }}</p>
            </div>
          </div>
          <div class="btn_wrap mt24">
            <button v-if="hasNext" @click="nextPage" class="btn btn_blue">もっと見る</button>
          </div>
        </div>
        <div v-else-if="cashFlowList.length == 0 && is_cashFlow_show" class="pl16 pr16">
          <p class="ab c5a">履歴がありません。<br />日付を変更して再度検索してください。</p>
        </div>
      </div>

      <Modal v-if="cashFlowModal" @setDate="setDate" />
    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">
      アクセスエラー<br />coNPusアプリから再度開き直してください。
    </div>
  </div>
</template>

<script>
import Check from "@/model/getToken";
import SectionTitle from "@/components/common/SectionTitle";
import Modal from "@/components/wallet/CashFlowModal";
import { mapGetters } from "vuex";
import Wallet from "@/components/api/wallet/wallet";

export default {
  components: {
    SectionTitle,
    Modal,
  },
  data() {
    return {
      isShow: true,
      is_cashFlow_show: false,
      isWalletAmountType: null,
      cashFlowList: [],
      currentPage: 1,
      hasNext: false,
    };
  },
  methods: {
    searchWalletAmountType(walletAmountType) {
      console.log(walletAmountType);
      this.isWalletAmountType = walletAmountType;
      this.apiGetCashFlow(this.fromDate, this.currentPage, this.toDate, this.isWalletAmountType);
    },
    formatDate(date, format) {
      date = new Date(date);
      format = format.replace(/yyyy/g, date.getFullYear());
      format = format.replace(/MM/g, ("0" + (date.getMonth() + 1)).slice(-2));
      format = format.replace(/dd/g, ("0" + date.getDate()).slice(-2));
      format = format.replace(/HH/g, ("0" + date.getHours()).slice(-2));
      format = format.replace(/mm/g, ("0" + date.getMinutes()).slice(-2));
      format = format.replace(/ss/g, ("0" + date.getSeconds()).slice(-2));
      format = format.replace(/SSS/g, ("00" + date.getMilliseconds()).slice(-3));
      return format;
    },
    nextPage() {
      this.currentPage += 1;
      this.apiGetCashFlow(this.fromDate, this.currentPage, this.toDate, this.isWalletAmountType);
    },
    setDate() {
      this.cashFlowList.splice(0, this.cashFlowList.length);
      this.is_cashFlow_show = false;
      this.apiGetCashFlow(this.fromDate, 1, this.toDate, this.isWalletAmountType);
    },
    // setDate() {
    //   this.cashFlowList.splice(0, this.cashFlowList.length);
    //   this.is_cashFlow_show = false;
    //   this.apiGetCashFlow(this.fromDate, 1, this.toDate, this.isWalletAmountType);
    // },
    modalOpen() {
      this.$store.commit("setCashFlowModal", true);
    },
    async apiGetCashFlow(fromDate, page, toDate, walletAmountType) {
      console.log(fromDate);
      console.log(toDate);
      await Wallet.getCashFlow(fromDate, page, toDate, walletAmountType).then((val) => {
        console.log("履歴");
        console.log(val);
        if (this.currentPage == 1) {
          this.currentPage = 1;
          this.cashFlowList.splice(0, this.cashFlowList.length);
        }
        this.is_cashFlow_show = true;
        this.cashFlowList.push(...val.cashFlowList);
        this.currentPage = val.currentPage;
        this.hasNext = val.hasNext;
      });
    },
    init() {
      // 日付初期化
      let date = new Date();
      date.setDate(1);
      this.$store.commit("setCashFlowFromDate", this.formatDate(date, "yyyy-MM-dd"));
      date.setMonth(date.getMonth() + 1);
      date.setDate(0);
      this.$store.commit("setCashFlowToDate", this.formatDate(date, "yyyy-MM-dd"));
      // データ初期化
      this.isWalletAmountType = "ALL";
      this.cashFlowList.splice(0);
    },
  },
  computed: mapGetters(["cashFlowModal", "fromDate", "toDate"]),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => {
      res = val;
    });
    console.log(res);
    if (res) {
      this.init();
      this.apiGetCashFlow(this.fromDate, this.currentPage, this.toDate, "ALL");
    } else {
      this.isShow = false;
    }
  },
};
</script>

<style lang="css" scoped>
.date_wrap {
    align-items: center;
    display: flex;
    justify-content: center;
}
.date_wrap .date {
    font-size: 16px;
}
.date_wrap .wave {
    margin: 0 8px;
}
.title_wrap {
    align-items: center;
    display: flex;
    justify-content: space-between;
}
.calendar_btn {
    background-color: transparent;
    border: none;
    padding: 0;
}

.search {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 28px 10px 0;
}
.search_btn {
    background-color: #fefefe;
    border: 1px solid #1db9b9;
    border-radius: 30px;
    color: #4fccd4;
    font-size: 13px;
    line-height: 1;
    padding: 14px 0;
    width: calc(33% - 3px);
}
.search_btn.select {
    background-color: #4fccd4;
    color: #fff;
}

.cashflow {
    /* mt48 */
}

.cashflow_item {
    align-items: center;
    border-bottom: 1px solid #c9c9c9;
    display: flex;
    justify-content: space-between;
    padding: 9px 0 20px;
}
.cashflow_title {
    font-size: 14px;
}
.cashflow_text {
    color: #878787;
    font-size: 12px;
    letter-spacing: 1px;
}
.cashflow_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}
.expired {
  text-align: right;
}
.price {
    align-items: center;
    display: flex;
    font-size: 20px;
}
.price .yen {
    font-size: 16px;
    margin-left: 2px;
}
.price.plus {
    color: #6f74ff;
}
.price.minus {
    color: #ff5858;
}
</style>



// WEBPACK FOOTER //
// src/views/wallet/cashFlow/CashFlow.vue